<template>
    <div>
        <GChart
            class="p-0"
            type="PieChart"
            :settings="{packages: ['corechart'], language: 'pt-br'}"
            :data="chartDataFinal"
            :options="chartOptions"
            v-on="loading = false"
        />
    </div>
</template>

<script>
export default {
    props: ['chartData', 'students'],
    data() {
        return {
            loading: true,
            chartOptions: {
                fontName: 'Inter',
                fontSize: 14,
                legend: {
                    position: 'end',
                    alignment: 'center',
                    maxLines: 2
                },
                pieSliceText: 'none' ,
                pieHole: 0.6,
                height: 170,
                chartArea: {width: '100%', height: '90%'},
                //bar: { groupWidth: '60%' },
                //isStacked: true
            }
        }
    },
    computed: {
        chartDataFinal() {
            return this.chartData
        }
    },
}
</script>

<style scoped>
.student{
    z-index: 10;
    height:200px;
    width: 64%;
    text-align:center;
    vertical-align: middle;
    position: absolute;
    top: 0;  /* chartArea top  */
    left: 0; /* chartArea left */
    margin-top: 35px;

    font-size: 60px;
}
</style>
